import type { NetworkKpis } from "@cryptors/api-client";
import { Stack, Typography } from "@mui/material";

import { KpiCard } from "./KpiCard";

const fmt = (n: number) => new Intl.NumberFormat("fr-FR").format(n);

interface NetworkSectionProps {
  data: NetworkKpis;
}

export const NetworkSection = ({ data }: NetworkSectionProps) => (
  <Stack gap={2}>
    <Typography variant="h6">
      Réseau Cryptors (France et international)
    </Typography>
    <Stack direction="row" gap={2} flexWrap="wrap">
      <KpiCard
        title="Nombre total de joueurs à CitC"
        value={fmt(data.players.total)}
      />
      <KpiCard
        title="Nombre total de collections disponibles dans CitC"
        value={fmt(data.collections.total)}
      />
      <KpiCard
        title="Nombre total d'œuvres publiées"
        value={fmt(data.cryptors.total)}
      />
      <KpiCard
        title="Nombre total de scans de QR codes"
        value={data.scans.total !== null ? fmt(data.scans.total) : "—"}
      />
    </Stack>
  </Stack>
);
